<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('Keys.title')}}</strong>
                <div class="float-right">
                  <!--<router-link :to="{ path: '/key'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('Key.new')}}</router-link>-->
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-success btn-sm" v-on:click="generateNew()">
                  <i class="fa fa-save"></i> {{$t('Keys.new')}}
                </button>
              </div>

              <div class="card-body card-block fColumn">

                <div class="fContent">
                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import AlertInPage from '@/components/AlertInPage.vue';

  import Api from '@/api/Api';
  //  id_store 	wsid 	text
  export default {
    name: 'Keys',
    data() {
      const modul = this;

      return {
        Helper: Helper,

        data: [],
        head: [


          {
            key: "id",
            title: "global.edit",
            searchField: false
            , roweditor: true
            , cbSave: function (e, index, headRow, dataRow) {
            return new Promise((resolve, reject) => {

              console.log("dataRow");
              console.log(dataRow);

              const data = {};
              data.active = dataRow.active;

              const req = {};
              req.id = dataRow.id;
              req.data = data;
              req.id_company = modul.state.id_company;

              modul.AlertInPage.msg = "form.in_progress";
              modul.AlertInPage.type = "warning";
              Api.saveApikey(req).then(function (res) {
                modul.AlertInPage.msg = "";
                if (res && res.result && res.data && res.data.id) {
                  modul.AlertInPage.msg = "form.save_succes";
                  modul.AlertInPage.type = "success";
                  setTimeout(function (e) {
                    modul.AlertInPage.msg = "";
                  }, Number(modul.AlertInPage.delay));
                  resolve();
                } else {
                  modul.AlertInPage.msg = "form.save_error";
                  modul.AlertInPage.type = "danger";
                  setTimeout(function (e) {
                    modul.AlertInPage.msg = "";
                  }, Number(modul.AlertInPage.delay));
                  reject();
                }
              }, function (e) {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
                reject();
              });


            })
          }
          },
          {
            key: "active",
            title: "Keys.active",
            i18Key: "global.yesno",
            editable: true,
            rowedittype: "checkbox"
          },
          {
            key: "key",
            title: "Keys.key",
          },
          {
            key: "key",
//            title: "Keys.key",
            addcopytoclipboardbutton: true,
            render: function (data, type, row, meta) {
              return '';
            }
          },

//          {
//            title: "Keys.dttitle",
//            data: "id",
//            link: true,
//            linkurl: "Key",
//            linkclass: "text-nowrap",
//            linkiconclass: "menu-icon fa fa-edit btn-link",
//            linktext: "", // Keys.linktext
//          }


//          render: function (data, type, row, meta) {
//        return '<a class="na" data-id="' + row.id + '">Szerkesztés</a>';
//      }

//          active
//          , {
//            key: "deleted",
//            title: "global.deleted",
//            searchField: true
//          }
        ]
        , breadcrumbstitle: 'Keys.title'
        , breadcrumbsData: [
          {
            'title': "Keys.title",
          },
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , advancedfeatures: false
        , state: {}
        , stateHash: ""
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          if (modul.state && modul.state.settings && modul.state.settings.advancedfeatures) {
            modul.advancedfeatures = modul.state.settings.advancedfeatures === "true";
          }
          modul.handleRights();
          this.getElements();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();
      if (modul.state && modul.state.settings && modul.state.settings.advancedfeatures) {
        modul.advancedfeatures = modul.state.settings.advancedfeatures === "true";
      }
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16, 20])) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getElements();

      },
      getElements(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        const id_company = modul.$store.state.id_company;
        Api.getKeys({id_company: id_company}).then(function (res) {
          if (res && res.result) {
            modul.data = Array.from(res.data);
          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      generateNew(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        const id_company = modul.$store.state.id_company;
        Api.generateKey({id_company: id_company}).then(function (res) {
          if (res && res.result) {
//            modul.data = Array.from(res.data);
          }
          modul.AlertInPage.msg = "";
          modul.getElements();
        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
          modul.getElements();
        });
      }
    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
    },
  };
</script>








